import {createSelector} from 'reselect';
import {getSettings} from '../../selectors';

const makeGetDoesOpttySubTypeRequireGenericBillingAddress = opttySubType => createSelector(
  [getSettings],
  settings => !!settings?.optty_sub_types_requiring_generic_billing_address?.includes(opttySubType),
);

export default makeGetDoesOpttySubTypeRequireGenericBillingAddress;
